// Spreadsheet templates of a hosted table, or of every table (routers/sheet_templates.py): an XLSX
// whose cells carry the dictionary (drop-downs, ranges, text-formatted identifiers, a drop-down of
// the existing keys) and a hidden `_unio` sheet, so a filled one imports without a mapping step;
// and, for members without Excel, the header row as CSV and the README as text.
// `base` is the route prefix: the hosted database (`/projects/{id}/data`, the default) or a frozen
// design version (`/projects/{id}/dbdesign/versions/{n}`, BuildPanel's "Templates per table"); both
// answer `{base}/template.xlsx` and `{base}/tables/{table}/template.{fmt}`. `label` is the hidden
// text naming the buttons for a screen reader (default " of {table}", and then not on the XLSX one).
import { useState } from "react";
import { api } from "../../api";
import { Btn } from "../../components/Shared";

const small = { padding: "5px 12px", fontSize: 13 };
const hidden = { position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)" };

export default function TemplateDownloads({ projectId, table, stem, base, label }) {
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState("");
  const prefix = base || `/projects/${projectId}/data`;
  const path = table ? `${prefix}/tables/${encodeURIComponent(table)}/template` : `${prefix}/template`;
  const get = async (ext, name) => {
    setError(null);
    setBusy(ext);
    try {
      await api.download(`${path}.${ext}`, name);
    } catch (err) {
      setError(err);
    } finally {
      setBusy("");
    }
  };
  const what = label ?? (table ? ` of ${table}` : " of every table");
  return (
    <span style={{ display: "inline-flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <Btn variant="secondary" style={small} disabled={!!busy}
           title="An XLSX to fill in: the dictionary's drop-downs and checks in its cells; it imports without a mapping step"
           onClick={() => get("xlsx", `${stem}.template.xlsx`)}>
        {busy === "xlsx" ? "Preparing…" : table ? "Template (XLSX)" : "Template of all tables (XLSX)"}
        {label && <span style={hidden}>{label}</span>}
      </Btn>
      {table && (
        <>
          <Btn variant="secondary" style={small} disabled={!!busy}
               onClick={() => get("csv", `${stem}.template.csv`)}>
            Header (CSV)<span style={hidden}>{what}</span>
          </Btn>
          <Btn variant="secondary" style={small} disabled={!!busy}
               onClick={() => get("txt", `${stem}.template.README.txt`)}>
            README (.txt)<span style={hidden}>{what}</span>
          </Btn>
        </>
      )}
      {error && <span role="alert" style={{ color: "#b91c1c", fontSize: 12 }}>{error.message}</span>}
    </span>
  );
}
